export default __webpack_public_path__ + "static/media/loveseat-2-seat-2-back.51c04b0c.webp";